module.exports = __webpack_public_path__ + "img/10.7c2e2706.jpg";